var _circle, _path, _polygon, _path2, _path3, _polygon2, _polygon3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8DemocraticRepublicCongoFlagCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#007fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M43.248,18.623c-0.679-2.436-1.807-4.678-3.29-6.644L5.59,31.822 c0.983,2.311,2.393,4.394,4.125,6.162L43.248,18.623z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fdd835",
    points: "13.009,9.891 14.361,14.031 18.715,14.037 15.196,16.602 16.536,20.745 13.009,18.191 9.482,20.745 10.821,16.602 7.303,14.037 11.657,14.031"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdd835",
    d: "M9.026,37.226c0.457,0.517,0.94,1.007,1.447,1.474l33.034-19.071 c-0.151-0.677-0.338-1.339-0.556-1.989L9.026,37.226z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdd835",
    d: "M40.561,12.787c-0.378-0.557-0.786-1.092-1.217-1.607L5.237,30.871 c0.232,0.634,0.495,1.253,0.788,1.855L40.561,12.787z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fdd835",
    points: "46.809,17.153 46.809,17.722 47.056,17.58"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fdd835",
    points: "1.967,32.759 1.718,32.902 1.967,33.334"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8DemocraticRepublicCongoFlagCircle);
export default __webpack_public_path__ + "static/media/icons8-democratic-republic-congo-flag-circle.661babff52af699301d130db6f1416aa.svg";
export { ForwardRef as ReactComponent };